import { render, staticRenderFns } from "./ConfirmPlan.vue?vue&type=template&id=4fa1b42b&"
import script from "./ConfirmPlan.vue?vue&type=script&lang=js&"
export * from "./ConfirmPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports